(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauNombreAccTrajetAvecSansArretCtrl', TableauNombreAccTrajetAvecSansArretCtrl);

    TableauNombreAccTrajetAvecSansArretCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauNombreAccTrajetAvecSansArretCtrl ($scope, $state, ParseLinks, AlertService) {
        var vm = this;




    }
})();
